import { Button, Tab, Table, TableCell, TablePager, TableRow } from '@fukuri-admins/ui/common';
import { StressAssessmentRole } from '~/types/model/stressAssessment';
import { RemindModal } from '../features/RemindModal';
import { Filter } from '../types';
import styles from './styles.module.scss';

type TabItem = {
  value: string;
  label: string;
};

type User = {
  id: string;
  name: string;
  branchName: string;
  isHighStress: boolean;
  isRowClickable: boolean;
};

type Props = {
  role?: StressAssessmentRole;
  selectedTabValue: Filter;
  tabItems: TabItem[];
  users: User[];
  pagerProps: React.ComponentProps<typeof TablePager>;
  isOpenRemindModal: boolean;
  threeLetterCode: string;
  stressAssessmentId: number;
  onFilterChange: (filter: Filter) => void;
  onOpenRemindModal: () => void;
  onCloseRemindModal: () => void;
  onRowClick?: (userId: string) => void;
};

export const StressAssessmentUserReportListPresentation: React.FC<Props> = ({
  role = 'practitioner',
  selectedTabValue,
  users,
  tabItems,
  pagerProps,
  isOpenRemindModal,
  threeLetterCode,
  stressAssessmentId,
  onFilterChange,
  onOpenRemindModal,
  onCloseRemindModal,
  onRowClick,
}) => {
  const headers = [
    { label: 'No', className: styles.colNo },
    ...(role === 'implementer'
      ? [{ label: 'ストレス判定', className: styles.colStressLevel }]
      : []),
    { label: '名前' },
    { label: '事業所' },
  ];

  return (
    <div className={styles.container}>
      <Tab items={tabItems} defaultSelectedValue={selectedTabValue} onClick={onFilterChange} />
      {selectedTabValue === 'pending' && (
        <div className={styles.remindButtonWrapper}>
          <Button variant='outline' onClick={onOpenRemindModal}>
            未回答者に再送信
          </Button>
        </div>
      )}
      <div className={styles.tableWrapper}>
        <Table headers={headers} fixedHeader maxHeight='384px'>
          {users.map(({ id, name, branchName, isHighStress, isRowClickable }) => (
            <TableRow
              key={id}
              onClick={isRowClickable && onRowClick ? () => onRowClick(id) : undefined}
            >
              <TableCell>{id}</TableCell>
              {role === 'implementer' && (
                <TableCell align='center'>
                  {isHighStress && (
                    <div className={styles.stressLevelBadge}>
                      <span className={styles.label}>高</span>
                    </div>
                  )}
                </TableCell>
              )}
              <TableCell>{name}</TableCell>
              <TableCell>{branchName}</TableCell>
            </TableRow>
          ))}
        </Table>
      </div>
      <TablePager {...pagerProps} />
      {isOpenRemindModal && (
        <RemindModal
          threeLetterCode={threeLetterCode}
          stressAssessmentId={stressAssessmentId}
          onClose={onCloseRemindModal}
        />
      )}
    </div>
  );
};
